import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let UserIndex = class UserIndex extends Vue {
    constructor() {
        super(...arguments);
        this.pageRef = null;
        this.resizeObserver = null;
    }
    mounted() {
        this.$nextTick(() => {
            this.initPageLayoutObserver();
            requestAnimationFrame(() => {
                this.updatePageLayout();
            });
        });
        window.addEventListener('resize', this.handleResize);
    }
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        window.removeEventListener('resize', this.handleResize);
    }
    initPageLayoutObserver() {
        const pageEl = this.$refs.pageRef;
        const parent = pageEl?.parentElement;
        if (!parent || typeof ResizeObserver === 'undefined') {
            return;
        }
        this.resizeObserver = new ResizeObserver(() => {
            this.updatePageLayout();
        });
        this.resizeObserver.observe(parent);
    }
    handleResize() {
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    updatePageLayout() {
        const pageEl = this.$refs.pageRef;
        if (!pageEl) {
            return;
        }
        const parent = pageEl.parentElement;
        let height = parent?.clientHeight || 0;
        if (height <= 0) {
            const rect = pageEl.getBoundingClientRect();
            const footerHeight = /^xs$|^sm$/i.test(this.$vuetify.breakpoint.name) ? 56 : 36;
            height = window.innerHeight - rect.top - footerHeight;
        }
        pageEl.style.height = `${Math.max(height, 300)}px`;
    }
};
UserIndex = __decorate([
    Component({
        name: 'Index'
    })
], UserIndex);
export default UserIndex;
;
